import { ThemeVariants } from 'src/types'

export const THEME_OPTIONS = Object.values(ThemeVariants)
